
function animationInView(element){
    const chartInViewClass = 'product-risk-chart--visible';
    element.classList.add(chartInViewClass);
}

export const productRiskChart = () => ({
    chart: {
        ['x-inview'](){
            animationInView(this.$el);
        }
    }
})  
